<mat-accordion>
  <!-- <mat-expansion-panel [expanded]=" true"> -->
    <!-- <mat-expansion-panel-header> -->
      <!-- <mat-panel-title>Itinerary Details</mat-panel-title> -->
    <!-- </mat-expansion-panel-header> -->

    <section >
      <!--- ITINERARY : Table Operations Menu-->
      <div class="itinerary-flex-container" >
        <div class="itinerary-button-container" >
          <button mat-mini-fab matTooltip="Up"  (click)="shiftItinerary('up')"
            [disabled]="!enableShiftUp" aria-label="row up">
            <mat-icon >arrow_upward</mat-icon>
          </button>
        </div>
        <div class="itinerary-button-container">
          <button mat-mini-fab matTooltip="Down"  (click)="shiftItinerary('down')"
            [disabled]="!enableShiftDown" aria-label="row down">
            <mat-icon>arrow_downward</mat-icon>
          </button>
        </div>
        <div class="itinerary-button-container">
          <!--  onclick="this.blur()"  ::> This is to manually remove focus on button after dialog closure -->
          <button mat-mini-fab matTooltip="Add Row"  onclick="this.blur()"
            (click)="addEditItinerary('Add')" aria-label="Add row" [disabled]="selection.selected.length > 1">
            <mat-icon>add</mat-icon>
          </button>
        </div>
        <div class="itinerary-button-container">
          <button mat-mini-fab matTooltip="Reverse"  (click)="reverseItinerary()"
            aria-label="reverse the table" [disabled]="isDrawPolygon">
            <mat-icon>swap_vert</mat-icon>
          </button>
        </div>
        <div class="itinerary-button-container">
          <button color="primary" mat-mini-fab matTooltip="Delete" (click)="deleteItinerary()"
          [disabled]="highlightedRows.length==0" aria-label="delete itinerary">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <div class="itinerary-button-container">
          <button mat-mini-fab matTooltip="Get Direction"  (click)="getDirections()"
            [disabled]="isDrawPolygon" aria-label="get map direction">
            <mat-icon>directions</mat-icon>
          </button>
        </div>
        <div class="itinerary-button-container">
          <button mat-mini-fab matTooltip="Clear Direction"  (click)="clearDirections()"
            [disabled]="isDrawPolygon" aria-label="clear map direction">
            <mat-icon>clear</mat-icon>
          </button>
        </div>
        <div class="itinerary-button-container">
          <button  mat-mini-fab matTooltip="Delete All" (click)="deleteAllItinerary()"
            [disabled]="!itinenaryDataSource.getValue().length" aria-label="delete all itinerary">
            <mat-icon>delete_forever</mat-icon>
          </button>
        </div>
        <div class="itinerary-button-container">
          <button  mat-mini-fab matTooltip="Optimise Itinerary" (click)="optimiseItinerary()"
            [disabled]="isDrawPolygon" aria-label="optimise itinerary">
            <mat-icon>schedule</mat-icon>
          </button>
        </div>
        <div class="itinerary-button-container">
          <button  mat-mini-fab matTooltip="Show Entire Itinerary" (click)="showEntireItinerary()"
            aria-label="Show Entire Itinerary" [disabled]="isDrawPolygon">
            <mat-icon style="margin-left: -5px !important;">fiber_manual_record</mat-icon>
          </button>
        </div>
        <div class="itinerary-button-container">
             <!-- CHANGED SHOW UTurn ICON -->
          <button  mat-mini-fab matTooltip="Single Calculation" (click)="showUTurn()" aria-label="UTurn"
            [disabled]="disabledUTurn" style="margin-left: -3px !important;margin-top: -1px;">
            <!-- <mat-icon>.redo.</mat-icon> -->
            <img src="../../../../assets/images/ArrowImage.png"  height="20.5" width="22">
          </button>
        </div>
      </div>
      <!-- ITINERARY : Waypoint count and Distance, Time -->
      <div class="itinerary-details mat-elevation-z1" *ngIf="itinenaryDataSource.getValue().length">
        <div class="row-details">
          <p>
            <label>Name: </label>
            <input type="text" placeholder="Ex: Itinerary Name" [(ngModel)]="currentItnName"
              (change)="onItnNameChange($event)">
          </p>
        </div>
        <div class="row-details">
          <p >
            <label >Waypoints: </label>
            <span >{{itinenaryDataSource.getValue().length}}</span>
          </p>
          <p *ngIf="distanceTime">
            <span >{{distanceTime.distance}} ({{distanceTime.time}}h)</span>
          </p>
        </div>
      </div>
      <!-- ITINERARY : Displaying Table data -->
      <div class=" itinerary-table-container mat-elevation-z3">
        
        <table mat-table [dataSource]="itinenaryDataSource" cdkDropList [cdkDropListData]="itinenaryDataSource"
          (cdkDropListDropped)="dropTable($event)" >


          <!-- Itinerary Name Column -->

          <ng-container matColumnDef="itineraryIndex">
            <th mat-header-cell *matHeaderCellDef > No </th>
            <td mat-cell *matCellDef="let row; let j = index"   > {{j+1}} 
              <!-- SCROLL BAR MOVE BASED ON ID -->
            <span id="{{j+1}}"></span>
          </td>
          </ng-container>
          <!-- Itinerary Name Column -->
          <ng-container matColumnDef="itineraryName">
            <th mat-header-cell  *matHeaderCellDef> Itinerary Name </th>
            <td  mat-cell *matCellDef="let row;let j = index">
              {{row.itineraryName}}
            </td>
          </ng-container>

          <!-- Longitude Column -->
          <ng-container matColumnDef="longitude">
            <th mat-header-cell *matHeaderCellDef style="display: none;"> Longitude </th>
            <td mat-cell *matCellDef="let row" style="display: none;">
              <span *ngIf="coordinateType == 0">
                {{ row.longitudeDD}}
              </span>
              <span *ngIf="coordinateType == 1">
                {{ row.longitudeDM}}
              </span>
              <span *ngIf="coordinateType == 2">
                {{ row.longitudeDMS}}
              </span>
            </td>
          </ng-container>

          <!-- Latitude Column -->
          <ng-container matColumnDef="latitude" >
            <th mat-header-cell *matHeaderCellDef style="display: none;"> Latitude </th>
            <td mat-cell *matCellDef="let row" style="display: none;" >
              <span *ngIf="coordinateType == 0">
                {{ row.latitudeDD}}
              </span>
              <span *ngIf="coordinateType == 1">
                {{ row.latitudeDM}}
              </span>
              <span *ngIf="coordinateType == 2">
                {{ row.latitudeDMS}}
              </span>
            </td>
          </ng-container>

          <tr mat-header-row style="overflow: scroll;height: 25px;"  *matHeaderRowDef="displayedColumns;" ></tr>
          <tr mat-row  style="height: 20px;"   *matRowDef="let row; columns: displayedColumns;" (click)="clickItinerary(row,$event)"
            (dblclick)="addEditItinerary('Edit',row)" 
            [ngClass]="{hovered: row.hovered, highlighted: selection.isSelected(row)}" (mouseover)="row.hovered = true"
            (mouseout)="row.hovered = false" cdkDrag [cdkDragData]="row" [style.background]="highlightedRows.indexOf(row) != -1 ? 'rgba(59,59,59,0.10196078431372549)' : ''" ></tr>           
        </table>
      </div>      
    </section>
 </mat-accordion>
